import { create, tsx } from '@dojo/framework/core/vdom';
import { IndustryExpertise } from './IndustryExpertise';
import * as commonCss from '../Common.m.css';

const factory = create();

export const IndustriesServed = factory(function IndustriesServed() {
	return (
		<IndustryExpertise>
			{{
				title: 'Industries We Serve',
				content: (
					<virtual>
						<p>
							Among SitePen's greatest strengths is its wide-ranging experience across
							multiple industries. We have worked with some of the most notable names
							in numerous markets, with each engagement serving to refine our ability
							to address each enterprise's individual needs. Among the industries that
							we have worked within are:
						</p>
						<ul classes={commonCss.list}>
							<li>Financial services</li>
							<li>Healthcare</li>
							<li>Hospitality</li>
							<li>Public Safety</li>
						</ul>
					</virtual>
				)
			}}
		</IndustryExpertise>
	);
});

export default IndustriesServed;
